module.exports = __webpack_public_path__ + "static/media/graduation-hat.16a1086f.svg";